import React, { useEffect } from 'react'

import Header from '../../components/Header/Header'
import UnderHeader from '../../components/UnderHeader/UnderHeader'
import PageTitle from '../../components/PageTitle/PageTitle'
import Footer from '../../components/Footer/Footer'
import LogoPartner from '../../components/LogoPartner/LogoPartner'
import ContactContent from '../../components/ContactContent/ContactContent'

export default function Contact() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <div>
      <Header page={'contact'} />
      <UnderHeader className={'contact'} />
      <PageTitle mainTitle={'CONTACT'} page={'CONTACT'} />
      <ContactContent />
      <LogoPartner />
      <Footer />
    </div>
  )
}
